export default __webpack_public_path__ + "static/media/email.cf483604.svg";